var map = {
	"./01 (1).gif:Zone.Identifier": 2556,
	"./EnvelopeSimple.svg": 948,
	"./Immanuel.svg": 925,
	"./Lucienne.svg": 5399,
	"./PhoneCall.svg": 3177,
	"./comments-icons.svg": 6237,
	"./course-details-image.svg": 4282,
	"./dashboard-icons.png": 7580,
	"./demo.gif": 3206,
	"./educators.svg": 494,
	"./feature1.jpg": 7331,
	"./feature2.jpg": 5605,
	"./feature3.jpg": 3266,
	"./franklin.svg": 9042,
	"./group-colors.svg": 5730,
	"./group-photo.svg": 5584,
	"./group-text.svg": 4045,
	"./image-users.gif": 4726,
	"./institutions.svg": 2680,
	"./karam.jpg": 7940,
	"./karam.jpg:Zone.Identifier": 377,
	"./logo.png": 9468,
	"./logo.svg": 8690,
	"./lucienne.jpg": 9340,
	"./lucienne.jpg:Zone.Identifier": 7435,
	"./pic1.jpg": 8595,
	"./pic1.jpg:Zone.Identifier": 9524,
	"./pic2.jpg": 9869,
	"./pic2.jpg:Zone.Identifier": 3954,
	"./pic3.jpg": 96,
	"./pic3.jpg:Zone.Identifier": 5993,
	"./profilePicture.jpg": 2229,
	"./shravya.jpg": 4633,
	"./shravya.jpg:Zone.Identifier": 2810,
	"./shravya.png": 1856,
	"./sign-up-group.svg": 5661,
	"./students.svg": 1693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2505;